import {MultiFanCoordinates} from "./multiFanNoise";
import {RequiredVisibilityRect} from "./RequiredVisibilityRect";

/**
 * Wentylator w chłodnicy - reprezentowany jako koło
 */
export class CoolerFan {
    private observedSpl: number | null = null;

    constructor(
        readonly centerCoordinates: MultiFanCoordinates,
        readonly caseDiameterMeters: number,
        readonly pwlDba: number,
        readonly fanNumber: number,
        readonly coolerZCoordinate: number
    ) {
    }

    /**
     * Ustawia obliczony SPL dla tego wentylatora
     */
    setObservedSpl(spl: number): void {
        this.observedSpl = spl;
    }

    /**
     * Pobiera obliczony SPL (lub null jeśli nie obliczono)
     */
    getObservedSpl(): number | null {
        return this.observedSpl;
    }

    getRequiredVisibilityRect(): RequiredVisibilityRect {
        const radius = this.caseDiameterMeters / 2;
        return new RequiredVisibilityRect(
            this.centerCoordinates.xMeters - radius,
            this.centerCoordinates.yMeters - radius,
            this.centerCoordinates.xMeters + radius,
            this.centerCoordinates.yMeters + radius
        );
    }

    renderToSVG(svgScale: number): string {
        const scaledRadius = (this.caseDiameterMeters / 2) * svgScale;
        const scaledX = this.centerCoordinates.xMeters * svgScale;
        const scaledY = this.centerCoordinates.yMeters * svgScale;

        // Rozmiary tekstu skalowane w stosunku do średnicy wentylatora
        const fontSizeNumber = 0.4 * svgScale; // Numer wentylatora
        const fontSizeDb = 0.3 * svgScale;    // dB(A)
        const fontSizeH = 0.3 * svgScale;      // H=
        const strokeWidth = 0.07 * svgScale;

        // Wyświetl obliczoną wartość SPL lub "? dB(A)" jeśli nie obliczono
        const splDisplay = this.observedSpl !== null
            ? `${this.observedSpl.toFixed(1)} dB(A)`
            : '? dB(A)';

        return `
            <g>
                <circle cx="${scaledX}" cy="${scaledY}" r="${scaledRadius}" fill="none" stroke="#0099ff" stroke-width="${strokeWidth}" />
                <text x="${scaledX}" y="${scaledY - scaledRadius * 0.18}" text-anchor="middle" font-size="${fontSizeNumber}" fill="#0099ff" font-weight="bold">${this.fanNumber}</text>
                <text x="${scaledX}" y="${scaledY + scaledRadius * 0.17}" text-anchor="middle" font-size="${fontSizeDb}" fill="#0099ff">${splDisplay}</text>
                <text x="${scaledX}" y="${scaledY + scaledRadius * 0.6}" text-anchor="middle" font-size="${fontSizeH}" fill="#666666">H=${this.coolerZCoordinate.toFixed(1)}</text>
            </g>
        `;
    }
}